export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/30 via-background-50 to-accent-100/20"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>日更连载 · 韩漫热榜 · 国漫追更</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              皮皮漫画网
              <br className="md:hidden" />
              <span className="text-primary-500"> 日韩与国漫精品推荐平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 mt-2 font-heading">
              追更不迷路，好漫一网打尽
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none">
              皮皮漫画网专注日韩与国漫精品推荐，覆盖韩漫排行榜实时更新、日漫系列全集下拉畅读、国漫大图高清全彩三大核心体验。无论你是韩漫控、日漫迷还是国漫爱好者，这里都能找到你想要的下一部好漫。每日更新，资源全面，追更快人一步。
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-8 mt-7 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-accent-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">12,000+</div>
                  <div className="text-xs text-foreground-500">漫画资源收录</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-timer-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">365天不间断</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-secondary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">80万+</div>
                  <div className="text-xs text-foreground-500">活跃追更读者</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始探索漫画
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold text-sm rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[420px] md:max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20anime%20themed%20illustration%20with%20comic%20panel%20layout%2C%20dynamic%20action%20lines%2C%20warm%20orange%20and%20coral%20accents%2C%20Japanese%20and%20Korean%20manhwa%20style%20characters%20reading%20comics%2C%20playful%20vibrant%20energy%2C%20clean%20minimal%20background%20with%20soft%20gradient%2C%20modern%20flat%20illustration%20style%2C%20artistic%20composition&width=960&height=720&seq=hero-manga-2026&orientation=landscape"
                alt="皮皮漫画网 - 日韩与国漫精品推荐平台主视觉图"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}